type EventCallback<T = any> = (event: CustomEvent<T>) => void

class EventBus {
  private target: EventTarget

  constructor() {
    this.target = new EventTarget()
  }

  /**
   * Emitir un evento con un nombre y datos asociados.
   * @param eventName El nombre del evento.
   * @param detail Los datos asociados al evento.
   */
  emit<T = any>(eventName: string, detail: T): void {
    const event = new CustomEvent<T>(eventName, { detail })
    this.target.dispatchEvent(event)
  }

  /**
   * Suscribirse a un evento con un callback.
   * @param eventName El nombre del evento.
   * @param callback La función que se ejecutará cuando ocurra el evento.
   */
  on<T = any>(eventName: string, callback: EventCallback<T>): void {
    this.target.addEventListener(eventName, callback as EventListener)
  }

  /**
   * Desuscribirse de un evento.
   * @param eventName El nombre del evento.
   * @param callback La función previamente registrada.
   */
  off<T = any>(eventName: string, callback: EventCallback<T>): void {
    this.target.removeEventListener(eventName, callback as EventListener)
  }
}

export const eventBus = new EventBus()
